import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { checkVerificationEmail } from '../../actions/users/registrationCreators';
import { getOrganisations } from '../../actions/organisations/basicCreators';
import { Grid, Row, Col, Alert } from 'react-bootstrap';
import Banner from '../../components/Banner';
import { Helmet } from 'react-helmet';
import LoadingSpinner from '../../components/LoadingSpinner';

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      message: undefined,
      messageType: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const token = this.props.location.query.token;
    this.props.checkVerificationEmail(token).then(
      user => {
        this.setState({ loading: false });
        if (user && user.isEmailVerified) {
          // display success message
          const message = 'Your email address has been successfully verified.';
          this.setState({ message, messageType: 'success' });

          // redirect after short delay
          this.timeoutId = setTimeout(() => {
            this.redirectUser(user);
          }, 3000);
        }
      },
      error => {
        const message = 'Your email could not be verified. Please try again.';
        this.setState({ message, messageType: 'danger' });
      }
    );
  }

  redirectUser = user => {
    // find out if user already has any organisations
    this.props.getOrganisations().then(response => {
      const { organisations } = this.props;
      if (organisations.length > 0) {
        // redirect to dashboard
        this.props.router.push('/');
      } else {
        // redirect to Create Company page
        this.props.router.push('/customer/create');
      }
    });
  };

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    }

    return (
      <div>
        <Helmet>
          <title>Verify Email | Campaign Targeter</title>
        </Helmet>
        <Banner title="Verify Email" image="mailbox" />
        <Grid>
          <Row>
            <Col xs={12}>
              {this.state.message && (
                <div>
                  <Alert bsStyle={this.state.messageType}>
                    {this.state.message}
                  </Alert>
                  <LoadingSpinner />
                </div>
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    organisations: state.organisations
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      checkVerificationEmail,
      getOrganisations
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);



// WEBPACK FOOTER //
// ./src/containers/account/VerifyEmail.js